import axiosInstance from '../plugin/axios';

interface FetchNoticeListParams {
  startDate: string;
  endDate: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface NoticeResponseData {
  noticeId: number;
  title: string;
  createdAt: string;
}

interface NoticeDetailsData {
  title: string;
  createdAt: string;
  content: string;
}

export const fetchNoticeList = async (
  params: FetchNoticeListParams,
): Promise<NoticeResponseData[]> => {
  console.log('params:', params);
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      limit = 1000,
      sortBy = 'createdAt',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<NoticeResponseData[]>(
      '/api/notice',
      {
        params: {
          startDate,
          endDate,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('공지사항 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('공지사항 데이터를 불러오는 데 실패했습니다.');
  }
};

export const getNoticeDetails = async (
  noticeId: number,
): Promise<NoticeDetailsData> => {
  try {
    const response = await axiosInstance.get<NoticeDetailsData>(
      `/api/notice/${noticeId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error('공지사항 상세 조회에 실패했습니다.');
  }
};
